module.exports = __webpack_public_path__ + "static/media/brian-cutout.0b780ee7.png";